import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import API from 'services/API';
import { TemplateSettingsUpdatePayload } from 'models/automation/TemplateSettings';

export const UPDATE_TEMPLATE_SETTINGS_MUTATION_KEY = 'update-template-settings';

type UpdateTemplateSettingsMutationArgs = TemplateSettingsUpdatePayload;

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<{}, BaseErrorResponse, UpdateTemplateSettingsMutationArgs>,
  'mutationFn'
>;

const updateSystemTemplate = ({
  ...payload
}: UpdateTemplateSettingsMutationArgs) => {
  return API.put<{}, BaseErrorResponse>(
    `/api/internal/automation/templates-settings`,
    payload,
  );
};

const useUpdateTemplateSettingsMutation = ({
  ...options
}: ReactQueryMutationOptions = {}) => {
  return useAppMutation({
    mutationFn: updateSystemTemplate,
    mutationKey: [UPDATE_TEMPLATE_SETTINGS_MUTATION_KEY],
    ...options,
  });
};

export default useUpdateTemplateSettingsMutation;
